import ContactForm from './ContactForm';

interface IBubbleLiblary {
    ContactForm: typeof ContactForm;
}

const bubbleLiblary = {
    ContactForm,
};

export { IBubbleLiblary, bubbleLiblary };
